module.exports = __webpack_public_path__ + "img/DunGenNew.8d21aeed.png";